import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { CircularProgress, Dialog, Skeleton, ThemeProvider, createTheme } from '@mui/material';
import SkeletonLoading from 'components/common/Skeleton';
import { globalAppTheme } from 'components/common/Themes/GlobalAppTheme';

const theme = createTheme(globalAppTheme,{
    components: {
      MuiAlert: {
        styleOverrides: {
          root: {
            backgroundColor: "white", // Replace with your desired background color,
            color:"black",
            // border:'2px solid rgb(173,73,112)',
            fontSize:'22px',
            fontWeight:"500",
            minHeight:'100px',
            textAlign:'center',
            padding:'20px'
          }
        }
      }
    }
  });
const useFetch = (url) => {

    const [loading,setLoading] = useState(true)
    const [data,setData] = useState([])
    const [error,setError] = useState('')

    useEffect(()=>{
        // const controller = new AbortController()
        (async ()=>{
            setLoading(true);
            try{
                let sp_id =  localStorage.getItem('sp_id');
                let customer_id =  localStorage.getItem('customer_id');
                let headers = {}
                // if(sp_id || customer_id){
                const token = localStorage.getItem('access_tokenSP'); // Retrieve the token from local storage
                 headers = { Authorization: `Bearer ${token}`  };      
                // }
                const {data, status} = await axios.get(url,{headers})
                if(data && status==200){
                    setData(data)
                    setError('')
                }
            }
            catch(error){
                setData([]);
                setError(error.message)
            }
            setLoading(false)
        })()

        // return ()=> controller.abort()
    },[])

    const reFetch = async() => {
        setLoading(true);
        try{
            const {data, status} = await axios.get(url)
            if(data && status==200 ){
                setData(data)
                setError('')
            }
        }
        catch(error){
            setData([]);
            setError(error.message)
        }
        setLoading(false)
    }

  return { data, loading ,error, reFetch}
}


const useFetchFunction = ()=>{
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [loading, setLoading] = useState(false);

    const fetchData = async ({url,method,payload,noLoading,noSnackbar})=>{
        try{
            if(!noLoading)setLoading(true);
            let sp_id =  localStorage.getItem('sp_id');
            let customer_id = localStorage.getItem('customer_id');
            let headers = {}
            const token = localStorage.getItem('access_tokenSP');
            if(sp_id){
            // const token = localStorage.getItem('access_tokenSP'); // Retrieve the token from local storage
            //  headers = { Authorization: `Bearer ${token}`  };      
             payload = {...payload, sp_id: sp_id}     
            }
            if (customer_id){
                // const token = localStorage.getItem('access_tokenSP'); // Retrieve the token from local storage
                // headers = { Authorization: `Bearer ${token}`  };     
            }
            const axiosRequest = {
                method:method?.toLowerCase()==='get' ? "GET" : "POST",
                url,
                headers :  { Authorization: `Bearer ${token}`  },
            }
               
            const {status,data} = await axios({...axiosRequest, data: method?.toLowerCase()==="post" && payload})
            // The legacy API signals failure with HTTP 200 + {error:true, message}, so
            // checking the status alone reports a failed write as a success (that's how
            // "Could not add the spare part" reached the user as a silent no-op).
            if(data && status ==200 && !data?.error){
                if(!noSnackbar){
                    setSnackbarSeverity('success');
                    setSnackbarMessage(data.message);
                    setOpenSnackbar(true);
                    setTimeout(() => {
                      setOpenSnackbar(false);
                    }, 3000);
                }

                return {isSuccess:true,data}
            }
            else {
                const serverMessage = data?.message || data?.detail || data?.title
                if(!noSnackbar){
                    setSnackbarSeverity('error');
                    setSnackbarMessage(serverMessage || 'Something went wrong');
                    setOpenSnackbar(true);
                    setTimeout(() => {
                      setOpenSnackbar(false);
                    }, 3000);
                }

                return {isSuccess:false, error:serverMessage}

            }
        }
        catch(error){
            // Legacy endpoints return {message}; /api/v1 (RFC 9457) returns {detail, title}.
            // Falling back straight to error.message (Axios's generic "Request failed
            // with status code 422") is how validation errors go silent on screen.
            const serverMessage = error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.title;
            if(!noSnackbar){
                setSnackbarSeverity('error');
                setSnackbarMessage(serverMessage || error?.message);
                setOpenSnackbar(true);
            }

            return {isSuccess:false, error:serverMessage || error?.message}
        }
        finally {
            if(!noLoading)setLoading(false);

        }
    }
    const loadingIndicator = loading ? <Dialog 
                                            open={true}
                                            PaperProps={{
                                                sx: {
                                                width: "200px",
                                                height: "100px",
                                                justifyContent:"center",
                                                alignItems:"center"
                                                }
                                            }}
                                            ><CircularProgress thickness={2} size="4rem"/>
                                        </Dialog> : null;

    return {
        fetchData,
        // Snackbar component
        snackbar: (
            <ThemeProvider theme={theme}>
            <Snackbar
            
            anchorOrigin={{
                vertical: "top",
                horizontal: "center"
             }}
            sx={{ height: "100%" }}
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={() => setOpenSnackbar(false)}
            >
            {/* was hardcoded to 'info', so failures rendered in the same neutral blue
                as successes — an error was easy to mistake for a completed action */}
            <Alert elevation={4} icon={false} severity={snackbarSeverity}>{snackbarMessage}</Alert>
            </Snackbar>
            </ThemeProvider>
        ),
        loadingIndicator
        }
}

const useCustomerFetchFunction = ()=>{
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
    const [loading, setLoading] = useState(false);
    const fetchCustomerData = async ({url,method,payload,noLoading,noSnackbar})=>{
        try{
            if(!noLoading)setLoading(true);
            // setLoading(true);
            let sp_id =  localStorage.getItem('sp_id');
            let customer_id = localStorage.getItem('customer_id');
            let headers = {}
            if(sp_id){
            const token = localStorage.getItem('access_tokenSP'); // Retrieve the token from local storage
             headers = { Authorization: `Bearer ${token}`  }; 
             payload = {...payload, sp_id: sp_id}     
            }
            if (customer_id){
                const token = localStorage.getItem('access_tokenSP'); // Retrieve the token from local storage
                headers = { Authorization: `Bearer ${token}`  };   
                let customer_email = localStorage.getItem('customer_email');
                payload = {...payload, email: customer_email}  
            }
            // Was hardcoded to GET/POST only; PATCH/PUT (e.g. the /api/v1 profile update)
            // silently became a POST here and 404'd against an Express router.patch route.
            const verb = method?.toUpperCase() || "POST";
            const axiosRequest = {
                method: verb,
                url,
                headers : headers,

            }
            const {status,data} = await axios({...axiosRequest, data: verb !== "GET" && payload})

            // Legacy endpoints return HTTP 200 with {error:true, message} on failure —
            // without this check a failed write is reported to the caller as a success.
            if(data && status ==200 && !data?.error){
                if(!noSnackbar){
                    setSnackbarSeverity('success');
                    setSnackbarMessage(data.message);
                    setOpenSnackbar(true);
                    setTimeout(() => {
                    setOpenSnackbar(false);
                    }, 2000);
                }
                return {isSuccess:true,data}
            }
            if(data?.error){
                if(!noSnackbar){
                    setSnackbarSeverity('error');
                    setSnackbarMessage(data?.message || 'Something went wrong');
                    setOpenSnackbar(true);
                    setTimeout(() => {
                    setOpenSnackbar(false);
                    }, 3000);
                }
                return {isSuccess:false, error:data?.message}
            }
        }
        catch(error){
            // Same as useFetchFunction above: without reading the response body,
            // every validation error shows as a generic "Request failed with
            // status code 422" — the actual reason never reaches the user.
            const serverMessage = error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.title;
            if(!noSnackbar){
                setSnackbarSeverity('error');
                setSnackbarMessage(serverMessage || error.message);
                setOpenSnackbar(true);
            }
            return {isSuccess:false, error:serverMessage || error.message}
        }
        finally {
            if(!noLoading)setLoading(false);

        }
        // finally {
        //     setLoading(false); // Set loading to false when the API call finishes
        //   }
          
    }
    const loadingIndicator = loading ? <SkeletonLoading/> : null;
    return {
        fetchCustomerData,
        // Exposed so callers can surface a client-side validation message (e.g.
        // "complete your profile first") through the same snackbar without a
        // round-trip to the server.
        setSnackbarSeverity, setSnackbarMessage, setOpenSnackbar,
        // Snackbar component
        snackbar: (
            <ThemeProvider theme={theme}>
            <Snackbar

            anchorOrigin={{
                vertical: "top",
                horizontal: "center"
             }}
            sx={{ height: "100%" }}
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={() => setOpenSnackbar(false)}
            >
            <Alert elevation={4} icon={false} severity={snackbarSeverity}>{snackbarMessage}</Alert>
            </Snackbar>
            </ThemeProvider>
        ),
        loadingIndicator
    }
}
export {useFetch,useFetchFunction,useCustomerFetchFunction}